import { g as n } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPrinter",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 1A.5.5 0 0 1 3 .5h6a.5.5 0 0 1 .5.5v3h.5a1.5 1.5 0 0 1 1.5 1.5V8A1.5 1.5 0 0 1 10 9.5h-.5V11a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V9.5H2A1.5 1.5 0 0 1 .5 8V5.5A1.5 1.5 0 0 1 2 4h.5V1Zm1 .5h5V4h-5V1.5ZM1.646 5.146A.5.5 0 0 1 2 5h8a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-.5V7a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5H2a.5.5 0 0 1-.5-.5V5.5a.5.5 0 0 1 .146-.354ZM3.5 10.5v-3h5v3h-5Z",
  fill: "currentColor"
}, null, -1), p = [
  u
], f = ["id"], m = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  m
];
function g(a, V, r, I, b, t) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--printer"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Printer",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, p, 8, _),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, h);
}
const z = /* @__PURE__ */ s(c, [["render", g]]);
export {
  z as default
};
//# sourceMappingURL=printer.js.map
